export default "__VITE_ASSET__BtwKNEOG__"